import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const StatsUp: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path d="M10.3198 27.225V24.12" strokeWidth="2" strokeLinecap="round" />
      <path d="M18 27.225V21.015" strokeWidth="2" strokeLinecap="round" />
      <path d="M25.6802 27.225V17.895" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M25.6798 8.77502L24.9898 9.58502C21.1648 14.055 16.0348 17.22 10.3198 18.645"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21.2852 8.77502H25.6802V13.155"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 33H22.5C30 33 33 30 33 22.5V13.5C33 6 30 3 22.5 3H13.5C6 3 3 6 3 13.5V22.5C3 30 6 33 13.5 33Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default StatsUp
